<template>
  <div id="app" style="width: 100vw !important">
    <notifications group="foo" position="top right" />
    <component :is="addLayout">
      <router-view
        @authenticated="setAuthenticated"
        authenticated="false"
      ></router-view>
    </component>
  </div>
</template>

<script>
var Cookies = require("vue-cookies");
var Config = require("../src/router/Config");
// var $ = require('jquery')
const defaultLayout = "defaultlayout";

export default {
  name: "App",
  data() {
    return {
      authenticated: false,
    };
  },
  mounted() {
    var redirectPath = this.$router.history._startLocation;
    var currentPath = this.$router.currentRoute.path;
    //get url using js -: vue method not stable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    //check url has token
    if (this.$route.query.token) {
      this.passwordResetRequestByEmailLink();
    }
    if (
      redirectPath !== "" &&
      redirectPath !== "/login" &&
      currentPath !== "/applogin" &&
      currentPath !== null
    ) {
      Cookies.set("redirectUrl", redirectPath);
    } else {
      Cookies.set("redirectUrl", "/dashboard");
    }

    if (Cookies.get("userId") > 0) {
      this.setAuthenticated(true);
    }

    if (
      !this.authenticated &&
      currentPath !== "/applogin" &&
      !urlParams.has("token")
    ) {
      this.$router.replace({ name: "login" });
    } else if (currentPath === "/applogin") {
      Cookies.set("is_app_log", true);
      this.appLoginAuthentication();
    }
    if (urlParams.has("token")) {
      Cookies.remove("redirectUrl");
      // this.passwordResetRequestByEmailLink();
    }
  },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
    },
    appLoginAuthentication() {
      this.axios
        .post(Config.API_URL + "/api/fe/auth/applogin", {
          studentId: this.$route.query.studentId,
        })
        .then((response) => {
          var result = response.data;
          console.log("appLoginAuthentication");
          console.log(result);
          if (result.res === "1") {
            Cookies.set("accessToken", result.data);
            Cookies.set("userId", result.id);
            Cookies.set("firstName", result.firstName);
            Cookies.set("lastName", result.lastName);
            Cookies.set("email", result.email);
            Cookies.set("profileImage", result.profileImage);
            Cookies.set("usertype", result.userType);
            Cookies.set("userDetail", result.user);
            Cookies.set("userPermissions", result.userPermissions);
            Cookies.set("clientId", result.clientId);
            Cookies.set("studentId", result.user.student[0].id);
            Cookies.set("company", result.companyData);
            Cookies.set("student_number", result.student_number);
            Cookies.set("appos", this.$route.query.appos);
            Cookies.set("is_app_log", true);
            this.$emit("authenticated", true);
            location.href = "/dashboard";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    passwordResetRequestByEmailLink() {
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/forget" +
            "?token=" +
            this.$route.query.token
        )
        .then((response) => {
          var result = response.data;
          if (result.res === "1") {
            this.$router.replace({ name: "login" });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {
    addLayout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },
};
</script>

<style scoped lang="scss">
@import "assets/css/main.css";
</style>
